import { useCallback } from 'react'
import { useI18n } from '../../i18n'
import { useSecuritySessions } from './useSecuritySessions'
import { useSecurityTeam } from './useSecurityTeam'

type Args = {
  token: string | null
  authHeaders: (withJson?: boolean) => Record<string, string>
}

function useSecurityCenter({ token, authHeaders }: Args) {
  const { t } = useI18n()

  const {
    sessions,
    sessionsLoading,
    loadSessions,
    trustSession,
    revokeSession,
    bootstrapSession,
    resetSessions,
  } = useSecuritySessions({
    token,
    authHeaders,
    t,
  })
  const {
    users,
    roles,
    capabilities,
    sections,
    teamLoading,
    loadTeam,
    createUser,
    createRole,
    updateUserRoles,
    resetTeam,
  } = useSecurityTeam({
    token,
    authHeaders,
    t,
  })

  const resetSecurity = useCallback(() => {
    resetSessions()
    resetTeam()
  }, [resetSessions, resetTeam])

  return {
    sessions,
    sessionsLoading,
    loadSessions,
    trustSession,
    revokeSession,
    bootstrapSession,
    resetSecurity,
    users,
    roles,
    capabilities,
    sections,
    teamLoading,
    loadTeam,
    createUser,
    createRole,
    updateUserRoles,
  }
}

export default useSecurityCenter
